"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReimbursementTypeEnum = void 0;
var ReimbursementTypeEnum;
(function (ReimbursementTypeEnum) {
    ReimbursementTypeEnum["STANDARD"] = "STANDARD";
    ReimbursementTypeEnum["MILEAGE"] = "MILEAGE";
    ReimbursementTypeEnum["HOSPITALITY"] = "HOSPITALITY";
    ReimbursementTypeEnum["PER_DIEM"] = "PER_DIEM";
})(ReimbursementTypeEnum || (exports.ReimbursementTypeEnum = ReimbursementTypeEnum = {}));
